
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { BaseUserClient, DeferredPaymentClient } from '@/services/Services';
import { Prop } from "vue-property-decorator";
import store from '@/store';

@Options({})
export default class payWithWireTransfer extends Vue {

    tempMail: string = "";
    modificaMail: boolean = false;

    acquistiInAttesa: OM.DeferredPayment[] = [];

    created(){
        DeferredPaymentClient.getPendingByCustomer(store.state.user.identifier)
        .then(x => {
            this.acquistiInAttesa = x;
        })
    }

    saveMail(){
        BaseUserClient.saveContactEmail(this.$store.state.user.identifier, this.tempMail)
        .then(x => {
            this.$store.state.user.contactData.email = this.tempMail;
            this.modificaMail = false;
        });
    }

};
